export default class FileModel {
  constructor() {
    this.fileId = '';
    this.fileName = '';
    // 編號
    this.category = '';
    this.url = '';
    this.comment = '';
    this.createdDate = '';
  }
}



// WEBPACK FOOTER //
// ./src/models/FIleModel.js